import TYPES from '../types';

export default () => {
  return {
    type: TYPES.DISABLE_SWAP,
  };
};
